import { render } from "./Userform.vue?vue&type=template&id=064de9a6&scoped=true"
import script from "./Userform.vue?vue&type=script&lang=js"
export * from "./Userform.vue?vue&type=script&lang=js"

import "./Userform.vue?vue&type=style&index=0&id=064de9a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064de9a6"]])

export default __exports__